<template>
  <v-container id="inccursada-ivt">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  dark
                  color="success"
                  class="alineacentro DatosMatriculado"
                >
                  <strong>INSCRIPCIÓN A CURSADAS</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="!roles.includes(1)">
              <v-col cols="12">
                <selector-alumno :habilitado="editando" ref="selalu" @selAlumno="asignaalumnofiltro" :nivel=4>
                </selector-alumno>
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="roles.includes(1) || (!roles.includes(1) && filtros.idalumno!=null && filtros.idalumno!=0)">
              <v-col cols="12" md="8" lg="8">
                <v-select
                  v-model="filtros.idcarrera"
                  :items="listacarreras"
                  label="Carrera"
                  item-text="carrera"
                  item-value="idcarrera"
                  height="20px"
                  :disabled="editando"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  v-model="filtros.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="anio"
                  height="20px"
                  :disabled="editando"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar"
                  @click="Listar"
                  :disabled="editando || filtros.idalumno===null || filtros.idalumno===0 || filtros.idcarrera===null || filtros.idcarrera===0 || filtros.anio===null || filtros.anio===0"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="editando">
              <v-col cols="12">
                <v-col cols="12" class="alineaderecha">
                  <v-btn color="blue darken-1" text @click="Imprimir">
                    Imprimir
                  </v-btn>
                  <v-btn color="green darken-1" text @click="EnviarCorreo">
                    Enviar Correo
                  </v-btn>
                  <v-btn color="red darken-1" text @click="Cerrar">
                    Cerrar
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="text-center"  v-if="editando">
              <v-col cols="12">
                <v-data-table
                  :headers="columnasinsc"
                  :items="listainscripciones"
                  :items-per-page="listainscripciones.length"
                  hide-default-footer
                  item-key="idasignatura"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                   <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="green"
                          @click="Inscribirse(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteinscribir"
                        >
                          <v-icon>mdi-thumb-up</v-icon>
                        </v-btn>
                      </template>
                      <span>Inscribirse</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="blue"
                          @click="Editar(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permitemodificar"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Modificar Inscripción</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="blue"
                          @click="Eliminar(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permitemodificar"
                        >
                          <v-icon>mdi-delete-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar Inscripción</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.cuatrimestre="{ item }">
                    {{ item.cuatrimestre===0 ? 'ANUAL' : item.cuatrimestre }}
                  </template>
                  <template v-slot:item.observacion="{ item }">
                    <v-banner v-if="item.observacion.length>0"
                        color="red"
                        elevation="5"
                        rounded
                    >{{ item.observacion }}</v-banner>
                  </template>
                  <template v-slot:item.tipocursada="{ item }">
                    <v-chip v-if="item.tipocursada!=null" :color="getcolortipocursada(item.idtipocursada)" dark>
                      <p class="textofilagrilla">{{ item.tipocursada }}</p>
                    </v-chip>
                  </template>
                  <template v-slot:item.estadocursadanombre="{ item }">
                    <v-chip :color="getcolorestado(item.estadocursadacod)" dark>
                      <p class="textofilagrilla">{{ item.estadocursadanombre }}</p>
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialoginscribe" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">
          {{ dialoginscribetitulo }}
        </v-card-title>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12">
              <v-select
                v-model="edited.iddivision"
                :items="listadivisionesxcurso"
                label="División"
                item-text="divisioncompleta"
                item-value="iddivision"
                height="20px"
              />
            </v-col>
          </v-row>
          <!-- <v-row class="text-center">
            <v-col cols="12">
              <v-select
                v-model="edited.idtipocursada"
                :items="listatiposcursada"
                label="Tipo"
                item-text="nombre"
                item-value="idtipocursada"
                height="20px"
              />
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="GuardarInscripcion">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialoginscribe = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
export default {
  name: "inscripcioncursada",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 5,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      filtros: {
        anio: 0,
        idcarrera: 0,
        idalumno: 0,
        alumno: ''
      },
      listainscripciones: [],
      columnasinsc: [
        {
          text: "Op.",
          value: "actions",
          width: 150
        },
        {
          text: "Obs.",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 200
        },
        {
          text: "Ciclo",
          align: "center",
          sortable: true,
          value: "ciclo",
          width: 90
        },
        {
          text: "Cod",
          align: "center",
          sortable: true,
          value: "codigoasignatura",
          width: 80
        },
        {
          text: "Asignatura",
          align: "center",
          sortable: true,
          value: "asignatura",
          width: 300
        },
        {
          text: "Cuat",
          align: "center",
          sortable: true,
          value: "cuatrimestre",
          width: 60
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocursada",
          width: 70
        },
        {
          text: "F Insc",
          align: "center",
          sortable: true,
          value: "fechainscripcion",
          width: 100
        },
        {
          text: "Div",
          align: "center",
          sortable: true,
          value: "codivision",
          width: 80
        },
        /* {
          text: "Division",
          align: "center",
          sortable: true,
          value: "division",
          width: 120
        }, */
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocursadanombre",
          width: 110
        },
        {
          text: "F Aprob",
          align: "center",
          sortable: true,
          value: "fechaaprobacion",
          width: 100
        }
      ],
      listaanios: [],
      listacarreras: [],
      edited: {
        iddivision: 0,
        idcursada: 0,
        idasignatura: 0,
        ciclolectivo: 0,
        idalumno: 0,
        usuario: '',
        idtipocursada: 1
      },
      editando: false,
      dialoginscribe: false,
      dialoginscribetitulo: '',
      listadivisionesxcurso: [],
      listatiposcursada: []
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        this.filtros.anio= (new Date()).getFullYear();
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2024;i<=anioactual;i++) {
          this.listaanios.push({anio: i});
        }
        if(this.roles.includes(1)) {
          axios.get('alumno/buscaalumno/ /' + this.usuario + '/0/0').then((result) => {
            if(result.data.resultado===0) {
              this.filtros.idalumno = result.data.datos.idalumno;
              var usuario= this.usuario
              axios.get('alumno/carrerasalumno/0/' + usuario + '/0/0').then((result) => {
                if(result.data.resultado===0) {
                  this.listacarreras = result.data.datos;
                  if(this.listacarreras.length>0) {
                    this.filtros.idcarrera=this.listacarreras[0].idcarrera;
                    var ia= 0;
                    var anioactual= (new Date()).getFullYear();
                    this.listaanios=[];
                    var inicio= parseInt(this.listacarreras[0].anioingreso)<2024 ? 2024 : parseInt(this.listacarreras[0].anioingreso);
                    for(ia=inicio; ia<=anioactual;ia++){
                      this.listaanios.push({anio: ia});
                    }
                    if(this.listaanios.length>0) {
                      this.filtros.anio=anioactual;
                    }
                  }
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          })
        }
        else{
          /* var parametro= {anio: 0};
          axios.post("inscripcioncarrera/PostCarrerasActivas", parametro, { headers: { "Content-Type": "application/json",}}).then((result) => {
            if(result.data.resultado===0){
                this.listacarreras = result.data.datos;
                this.filtros.idcarrera= this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0;
                axios.get("referenciales/tipocursada").then((result) => {
                    if(result.data.resultado===0) {
                      this.listatiposcursada = result.data.datos;
                      this.loading=false;
                    }
                  }).catch((error) => {
                    this.loading = false;
                    this.MostrarMensaje('Error', error, false);
                  });
            }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
          }); */
        }
        axios.get("referenciales/tipocursada").then((result) => {
          if(result.data.resultado===0) {
            this.listatiposcursada = result.data.datos;
            this.loading=false;
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar() {
      if(this.filtros.idalumno!=null && this.filtros.idalumno!='' && this.filtros.idcarrera!=null && this.filtros.idcarrera!='' && this.filtros.anio!=null && this.filtros.anio!='')
      {
        this.loading = true;
        var usuario= this.usuario;
        var anio= this.filtros.anio;
        var idcarrera= this.filtros.idcarrera;
        var idalumno= this.filtros.idalumno!=0 ? this.filtros.idalumno : '0';
        axios.get('cursada/lista/' + usuario + '/' + anio + '/' + idcarrera + '/' + idalumno).then((result) => {
          if(result.data.resultado===0){
            this.listainscripciones = result.data.datos;
            this.editando=true;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.MostrarMensaje("Error", 'Debe seleccionar carrera, año y estudiante', false);
      }
    },
    asignaalumnofiltro (value) {
        this.filtros.idalumno = value != null ? value.idalumno : 0;
        this.filtros.alumno= value != null ? value.apellido + ' ' + value.nombre : '';
        if(this.filtros.idalumno!=0){
          this.loading= true;
          axios.get('alumno/buscaalumno/0/ /' + this.filtros.idalumno + '/0').then((result) => {
            if(result.data.resultado===0){
              //this.filtros.idalumno = result.data.datos.idalumno;
              //var usuario= this.usuario
              axios.get('alumno/carrerasalumno/0/ /' + this.filtros.idalumno + '/0').then((result) => {
                if(result.data.resultado===0){
                  this.listacarreras = result.data.datos;
                  if(this.listacarreras.length>0){
                    this.filtros.idcarrera=this.listacarreras[0].idcarrera;
                    var ia= 0;
                    var anioactual= (new Date()).getFullYear();
                    this.listaanios=[];
                    var inicio= parseInt(this.listacarreras[0].anioingreso)<2024 ? 2024 : parseInt(this.listacarreras[0].anioingreso);
                    for(ia=inicio; ia<=anioactual;ia++){
                      this.listaanios.push({anio: ia});
                    }
                    if(this.listaanios.length>0){
                      this.filtros.anio=anioactual;
                    }
                  }
                  this.loading=false;
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          })
        }
    },
    Cerrar () {
      this.listainscripciones= [];
      this.editando=false;
    },
    Inscribirse (item) {
      var parametro= JSON.stringify({idasignatura: item.idasignatura, ciclolectivo: this.filtros.anio, idalumno: this.filtros.idalumno, usuario: this.usuario });
      axios.post("cursada/PostDivisionesxCurso", parametro, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listadivisionesxcurso = result.data.datos;
          this.dialoginscribetitulo='Agregar Inscripción a ' + item.asignatura + ' para el ciclo ' + item.ciclo;
          this.edited = {
            iddivision: this.listadivisionesxcurso[0].iddivision,
            idcursada: item.idcursada!=null ? item.idcursada : 0,
            idasignatura: item.idasignatura,
            ciclolectivo: item.ciclo,
            idalumno: this.filtros.idalumno,
            usuario: this.usuario,
            idtipocursada: 1
          };
          this.dialoginscribe=true;
          this.loading=false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    Editar (item) {
      var parametro= JSON.stringify({idasignatura: item.idasignatura, ciclolectivo: this.filtros.anio, idalumno: this.filtros.idalumno, usuario: this.usuario});
      axios.post("cursada/PostDivisionesxCurso", parametro, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listadivisionesxcurso = result.data.datos;
          this.dialoginscribetitulo='Modificar Inscripción a ' + item.asignatura + ' para el ciclo ' + item.ciclo;
          this.edited = {
            iddivision: item.iddivision,
            idcursada: item.idcursada,
            idasignatura: item.idasignatura,
            ciclolectivo: item.ciclo,
            idalumno: this.filtros.idalumno,
            usuario: this.usuario,
            idtipocursada: item.idtipocursada
          };
          this.dialoginscribe=true;
          this.loading=false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    async Eliminar (item) {
      if (await this.$refs.confirm.open('Confirmar Eliminación de Inscripción','Esta seguro de querer borrar la inscripción?')) {
        this.loading=true;
        const cursada = JSON.stringify({idcursada: item.idcursada, usuario: this.usuario});
        axios.post("cursada/PostEliminarCursada", cursada, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.Listar();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    GuardarInscripcion () {
      if(this.edited.iddivision!=null && this.edited.iddivision!='' && this.edited.idtipocursada!=null && this.edited.idtipocursada!=''){
        this.loading=true;
        const cursada = JSON.stringify(this.edited);
        axios.post("cursada/PostCursada", cursada, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialoginscribe= false;
            this.Listar();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.MostrarMensaje('Error','Debe seleccionar división y tipo de cursada!', false)
      }
    },
    getcolorestado(estado) {
      if (estado === 0) {return "grey";}
      else if (estado === 1) {return "green";}
      else if (estado === 2) {return "red";}
      else if (estado === 3) {return "blue";}
      else if (estado === 4) {return "blue";}
    },
    getcolortipocursada(tipo){
      if (tipo === 1) {return "green";}
      else if (tipo === 2) {return "blue";}
      else if (tipo === 3) {return "grey";}
      else if (tipo === 4) {return "red";}
    },
    EnviarCorreo () {
      this.loading = true;
      axios.post("cursada/PostEnviarCursadas", {usuario: this.usuario, listaparametros: [{ orden: 1, nombre: "anio", valor: this.filtros.anio.toString()}, { orden: 2, nombre: "usuario", valor: this.usuario}, { orden: 3, nombre: "idcarrera", valor: this.filtros.idcarrera.toString()},{ orden: 4, nombre: "idalumno", valor: this.filtros.idalumno.toString()} ], idalumno: this.filtros.idalumno,alumno: this.filtros.alumno, idcarrera: this.filtros.idcarrera, carrera: this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].carrera },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if(result.data.resultado===0){
            this.MostrarMensaje('Atención','El listado fue enviado por correo de forma exitosa!', false);
          }else{
            this.MostrarMensaje('Error',result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    Imprimir () {
      this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 8, formato: 'PDF', listaparametros: [{ orden: 1, nombre: "anio", valor: this.filtros.anio.toString()}, { orden: 2, nombre: "usuario", valor: this.usuario}, { orden: 3, nombre: "idcarrera", valor: this.filtros.idcarrera.toString()},{ orden: 4, nombre: "idalumno", valor: this.filtros.idalumno.toString()} ] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    }
},
  computed: {
    /* fechalocalfecnac: function () {
      if (this.edited.fechanac != null && this.edited.fechanac != "") {
        var fecha = new Date(this.edited.fechanac);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }, */
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>